import { render } from "./Gift-card-codes.vue?vue&type=template&id=e077c7b6&scoped=true"
import script from "./Gift-card-codes.vue?vue&type=script&lang=js"
export * from "./Gift-card-codes.vue?vue&type=script&lang=js"

import "./Gift-card-codes.vue?vue&type=style&index=0&id=e077c7b6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e077c7b6"]])

export default __exports__